var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDance3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 569,
    viewBox: "0 0 352 569",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2120_10879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.892 568.621C177.05 568.621 215.261 548.925 233.787 510.113L238.419 561.67H287.051V135.312H233.208V324.161C214.103 289.403 177.629 270.287 134.208 270.287C50.2594 270.287 -0.109375 334.009 -0.109375 420.902C-0.109375 507.216 49.6806 568.621 131.892 568.621ZM142.892 519.381C87.3124 519.381 54.8911 477.672 54.8911 419.164C54.8911 361.235 87.3124 319.526 142.892 319.526C198.471 319.526 232.63 361.235 232.63 419.164C232.63 478.252 198.471 519.381 142.892 519.381Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2120_10879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 569,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDance3);
export default __webpack_public_path__ + "static/media/dance3.7f047ba7ebb88cff650e81bd921e150a.svg";
export { ForwardRef as ReactComponent };